export interface Sale {
  order_id: number;
  payment_method: string;
  events: [
    {
      title: string;
      thumbnail: string;
    },
  ];
  payment_status: SalePaymentStatusEnum;
  buyer: string;
  date: string;
  hour: string;
  quantity: number;
  total: number;
  seller?: {
    id: number;
    name: string;
  } | null;
}

export enum SalePaymentStatusEnum {
  CANCELADO = "cancelled",
  PAGO = "paid",
  RECEBIVEL = "receivable",
  CORTESIA = "courtesy",
  TRANSFERIDO = "transferred",
  REEMBOLSADO = "refunded",
}
